import React, { useState } from 'react'
import SimpleReactValidator from 'simple-react-validator';
import ReCAPTCHA from 'react-google-recaptcha';


const ContactForm = () => {

    const [forms, setForms] = useState({
        name: '',
        email: '',
        productname: '',
        mobile: '',
        message: ''
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitStatus, setSubmitStatus] = useState('');
    const [captchaValue, setCaptchaValue] = useState(null);
    const [validator] = useState(new SimpleReactValidator({
        className: 'errorMessage'
    }));
    const changeHandler = e => {
        setForms({ ...forms, [e.target.name]: e.target.value })
        if (validator.allValid()) {
            validator.hideMessages();
        } else {
            validator.showMessages();
        }
    };

   const submitHandler = async (e) => {
    e.preventDefault();

    if (!validator.allValid()) {
        validator.showMessages();
        return;
    }

    if (!captchaValue) {
        setSubmitStatus('captcha');
        return;
    }

    setIsSubmitting(true);
    setSubmitStatus('');

    const formData = {
        name: forms.name,
        email: forms.email,
        productname: forms.productname,
        mobile: forms.mobile,
        message: forms.message
    };

    try {
        // const response = await fetch("http://localhost/div/contact.php", {
        //     method: "POST",
        //     headers: { "Content-Type": "application/x-www-form-urlencoded" },
        //     body: new URLSearchParams(formData).toString(),
        // });

          const response = await fetch("/contact.php", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: new URLSearchParams(formData).toString(),
        });

        const result = await response.text();

        if (result.trim() === "success") {
            setSubmitStatus("success");
            setForms({ name: "", email: "", productname: "", mobile: "", message: "" });
            setCaptchaValue(null);
        } else {
            setSubmitStatus("error");
        }
    } catch (error) {
        setSubmitStatus("error");
    }

    setIsSubmitting(false);
};


    return (
        <form onSubmit={(e) => submitHandler(e)} className="contact-validation-active" >
            <div className="row">
                <div className="col col-lg-6 col-12">
                    <div className="form-field">
                        <input
                            value={forms.name}
                            type="text"
                            name="name"
                            onBlur={(e) => changeHandler(e)}
                            onChange={(e) => changeHandler(e)}
                            placeholder="Your Name" />
                        {validator.message('name', forms.name, 'required|alpha_space')}
                    </div>
                </div>
                <div className="col col-lg-6 col-12">
                    <div className="form-field">
                        <input
                            value={forms.email}
                            type="email"
                            name="email"
                            onBlur={(e) => changeHandler(e)}
                            onChange={(e) => changeHandler(e)}
                            placeholder="Your Email" />
                        {validator.message('email', forms.email, 'required|email')}
                    </div>
                </div>
                <div className="col col-lg-6 col-12">
                    <div className="form-field">
                        <input
                            value={forms.mobile}
                            type="tel"
                            name="mobile"
                            onBlur={(e) => changeHandler(e)}
                            onChange={(e) => changeHandler(e)}
                            placeholder="Your Mobile" />
                        {validator.message('mobile', forms.mobile, 'required|phone')}
                    </div>
                </div>
                <div className="col col-lg-6 col-12">
                    <div className="form-field">
                        <select
                            onBlur={(e) => changeHandler(e)}
                            onChange={(e) => changeHandler(e)}
                            value={forms.productname}
                            name="productname"
                            className="dropdown-down"
                            style={{direction: 'ltr'}}>
                            <option value="">Product Looking For</option>
                            <option value="HCL">HCL</option>
                            <option value="Hydrated Lime">Hydrated Lime</option>
                            <option value="Quick Lime">Quick Lime</option>
                            <option value="Activated Carbon">Activated Carbon</option>
                            <option value="Dolomite">Dolomite</option>
                            <option value="Di Methyl Sulphate">Di Methyl Sulphate</option>
                            <option value="Sodium Aluminate">Sodium Aluminate (Solution and Powder form)</option>
                            <option value="3,3 DNDS">3,3 DNDS (3,3 DI Nitro Di Phenyl Sulphone)</option>
                        </select>
                        {validator.message('productname', forms.productname, 'required')}
                    </div>
                </div>
                <div className="col col-lg-12 col-12">
                    <textarea
                        onBlur={(e) => changeHandler(e)}
                        onChange={(e) => changeHandler(e)}
                        value={forms.message}
                        type="text"
                        name="message"
                        placeholder="Message">
                    </textarea>
                    {validator.message('message', forms.message, 'required')}
                </div>
                <div className="col col-lg-12 col-12">
                    <ReCAPTCHA
                        sitekey="6LdK-zksAAAAAGiUA8rtRoYJcefiQ-I-hK0tZdc-"
                        onChange={(value) => setCaptchaValue(value)}
                    />
                </div>
            </div>
            <div className="submit-area">
                <button type="submit" className="theme-btn" disabled={isSubmitting}>
                    {isSubmitting ? 'Sending...' : 'Submit Now'}
                </button>
                {submitStatus === 'success' && <p style={{color: 'green', marginTop: '10px'}}>Message sent successfully!</p>}
                {submitStatus === 'error' && <p style={{color: 'red', marginTop: '10px'}}>Failed to send message. Please try again.</p>}
                {submitStatus === 'captcha' && <p style={{color: 'red', marginTop: '10px'}}>Please complete the captcha verification.</p>}
            </div>
        </form >
    )
}

export default ContactForm;